<script>
export default {
  data() {
    return {
      
    }
  }
}
</script>

<template>
  <div :class="$style.sectionContact">
    <div class="container section">
      <div class="row sectionContact__list">
        <div class="col-lg-4 col-12 sectionContact__item--left text-lg-left text-center">
          <img
            src="@assets/images/home/section5-image.png" 
            srcset="@assets/images/home/section5-image.png 1x, @assets/images/home/section5-image@2x.png 2x"  
            alt=""
          >
          <!-- <img src="@assets/images/home/section5-image.png" alt=""> -->
        </div>
        <div class="col-lg-8 col-12 sectionContact__item--right align-self-center text-lg-left text-center">
          <span class="font-cursive ls-0 color-primary">Ready to start?</span>
          <h3 class="sectionContact__title mb-4">
            想知道更多? 讓我們幫助您！
          </h3>
          <p class="sectionContact__content">
            We are Here to help! <br>
            不確定您適合哪種方案？iPetBooking可安排專人為您演示demo！請留下您的聯繫方式，我們將盡快與您聯絡，為您解答所有疑問。
          </p>
          <BaseButton :to="{ name: 'contact' }" class="isStylePrimary">
            專人聯繫 <i class="icomoon icon-arrow-button"></i>
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionContact{
    :global {
      .sectionContact {
        &__item{
          &--right {
            padding-left: 90px;
            @include max-lg {
              padding-left: 20px;
              margin-top: 36px;
            }
          }
        }
        &__title {
          font-size: 40px;
          font-weight: 600;
          line-height: 1.5;
          @include max-md {
            font-size: 30px;
          }
        }
        &__content {
          margin-bottom: 50px;
          color: $color-text-2;
          @include max-md {
            font-size: 14px;
          }
        }
      }
    }

    
  }
</style>